"use client";

import { Container } from 'react-bootstrap';
import { TopBar, TopNavBar, Footer } from '@/layout';

export default function LegalPageLayout({
  title,
  description,
  lastUpdated,
  children,
}) {
  return (
    <>
      <TopBar />
      <TopNavBar />
      <main>
        <section className="py-5 py-lg-6">
          <Container>
            <div className="mx-auto" style={{ maxWidth: '920px' }}>
              <header className="mb-4 mb-lg-5">
                <h1 className="h2 mb-3">{title}</h1>
                <p className="text-secondary mb-1">{description}</p>
                <p className="small text-muted mb-0">Last updated: {lastUpdated}</p>
              </header>
              <article className="legal-page-content">{children}</article>
            </div>
          </Container>
        </section>
      </main>
      <Footer />
    </>
  );
}
